import { PDFDownloadLink } from "@react-pdf/renderer";
import ProviderPDF from "./ProviderPDF";

import ExportPdf from "./picture/export.png"

const ExportButton = ({ provider }) => (
    <PDFDownloadLink document={<ProviderPDF provider={provider} />} fileName={`${provider.name}.pdf`}>
        {({ loading }) => (
            <button className="export-btn">
                <img src={ExportPdf} />
            </button>
        )}
    </PDFDownloadLink>
);

export default ExportButton;
